<template>
  <!-- 求购商品 -->
  <div class="wantBuy">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
        <!-- <el-button type="primary" icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)">新增PC导航</el-button> -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="留言编号"
      >
      </el-table-column>
      <el-table-column
        prop="userId"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        label="单位名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="求购商品"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="num"
        label="求购数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="求购价格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="求购时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="des"
        label="备注信息"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="reply"
        label="回复"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != -1"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >回复</el-button
          >
          <el-button
            v-show="scope.row.status != -1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 回复 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">回复</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="回复内容" prop="reply">
              <el-input v-model="addForm.reply" type="textarea"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护客户在“求购专区”提交的求购数据，管理员可进行回复</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "wantBuy",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        name: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: "",
        reply: "",
      },
      addFormRule: {
        reply: [mustFill],
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "GoodsReply",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => ({
              id: item.Id, // 求购编号
              userId: item.userId, // 客户编号
              userName: item.businessname, // 单位名称
              name: item.buyGoods, // 求购商品
              factory: item.productName, // 生产厂家
              spec: item.buySpec, // 商品规格
              num: item.buyNumber, // 求购数量
              price: item.buyPrice, // 求购价格
              time: item.recordDate, // 求购时间
              des: item.message, // 备注信息
              reply: item.reply, // 回复
            }));
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        this.handleStatus(row);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
    },
    /**更改状态 */
    handleStatus(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "DeleteOperation",
            id: row.id,
          };
          let proc = "Proc_Admin_Statistical"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "goods/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "OperationNotes",
            id: this.addForm.id,
            reply: this.addForm.reply,
          };
          let proc = "Proc_Admin_Statistical"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "goods/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.wantBuy {
  width: 100%;
  height: 100%;
}
</style>
